module.exports = __webpack_public_path__ + "img/3-2.aafe7d33.png";